import React from 'react';
import { Link } from 'react-router-dom';
import { BadgePercent } from 'lucide-react';

const formatDate = (date) => {
	if (!date) return 'No date';
	return new Date(date).toLocaleDateString('en-CA', {
		month: 'short',
		day: 'numeric',
		year: 'numeric',
	});
};

const DealsPreview = ({ deals }) => {
	const recentDeals = deals.slice(0, 4);

	return (
		<div className='dashboard-panel'>
			<div className='dashboard-panel__header'>
				<div>
					<h3 className='dashboard-panel__title'>Recent Group Deals</h3>
					<p className='dashboard-panel__subtitle'>
						Your latest building-targeted offers
					</p>
				</div>

				<Link to='/deals' className='dashboard-panel__link'>
					View all
				</Link>
			</div>

			{recentDeals.length > 0 ? (
				<div className='dashboard-list'>
					{recentDeals.map((deal) => (
						<div className='dashboard-list-item' key={deal._id}>
							<div className='dashboard-list-item__icon dashboard-list-item__icon--deal'>
								<BadgePercent size={18} />
							</div>

							<div className='dashboard-list-item__body'>
								<h4>{deal.title}</h4>
								<p>
									{deal.discountedPrice
										? `CD$ ${deal.discountedPrice}`
										: 'Special price'}{' '}
									· {deal.status || 'draft'}
								</p>
							</div>

							<div className='dashboard-list-item__meta'>
								{formatDate(deal.serviceDate)}
							</div>
						</div>
					))}
				</div>
			) : (
				<div className='dashboard-empty'>
					No group deals yet. Create your first deal to start marketing to
					buildings.
				</div>
			)}
		</div>
	);
};

export default DealsPreview;
